import { render, staticRenderFns } from "./ManageTopicNotifications.vue?vue&type=template&id=12ba4d95&"
import script from "./ManageTopicNotifications.vue?vue&type=script&lang=ts&"
export * from "./ManageTopicNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTopicNotifications.vue?vue&type=style&index=0&id=12ba4d95&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports